import { WSPillProps } from "@wingspanhq/fe-component-library";
import { IInvoiceRow, InvoiceRowStatus } from "../../service";

export const getInvoiceStatusPillProps = (
  invoice: IInvoiceRow
): WSPillProps => {
  switch (invoice.status) {
    case InvoiceRowStatus.AwaitingClient:
      return {
        theme: "neutral",
        icon: "time",
        text: "Awaiting client"
      };

    case InvoiceRowStatus.ActionRequired:
      return {
        theme: "warning",
        icon: true,
        text: "Action required"
      };

    case InvoiceRowStatus.InProgress:
      return {
        theme: "blue",
        icon: "send-mail",
        text: "In-progress"
      };

    case InvoiceRowStatus.Deposited:
      if (!!invoice.events.markedPaidAt) {
        return {
          theme: "neutral",
          icon: "paperclip",
          text: "Off-platform"
        };
      } else {
        return {
          theme: "success",
          icon: true,
          text: "Deposited"
        };
      }
    case InvoiceRowStatus.Refunded:
      return {
        theme: "neutral",
        icon: "undo",
        text: "Refunded"
      };
    case InvoiceRowStatus.Draft:
      return {
        theme: "neutral",
        icon: "draft",
        text: "Draft"
      };
    default:
      return {
        theme: "neutral",
        text: "Unknown"
      };
  }
};
